import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerUnknown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>{".schema-viewer-unknown_svg__st0{fill:#666}"}</style>
    <path
      id="schema-viewer-unknown_svg__Dot_1_"
      className="schema-viewer-unknown_svg__st0"
      d="M10.86 14v-1.14H12V14h-1.14z"
    />
    <path
      id="schema-viewer-unknown_svg__Mark_1_"
      className="schema-viewer-unknown_svg__st0"
      d="M10.86 11c-.03-.305 0-.719 0-1.053 0-.66.1-1.135 1.419-2.032 1.066-.76 1.713-1.17 1.713-2.19 0-.978-.78-1.7-2.07-1.7-1.23 0-2.196.596-2.811 1.384l-.823-.668c.84-1.035 1.92-1.743 3.645-1.743 2.04 0 3.082 1.19 3.082 2.735 0 1.399-.553 1.948-1.687 2.76C12.069 9.383 12 9.426 12 11h-1.14z"
    />
  </svg>
);
const Memo = memo(SvgSchemaViewerUnknown);
export default Memo;
